import 'owl.carousel';

export function sliders()
{
	let sliders = $('.project-content__slider');

	sliders.each(function(){
		//Change the options here - you can use data-* tags to specify different values for different sliders
		let options = {
				items: 1,
				stagePadding: 220,
				margin: 110,
				loop: false,
				center: true,
				smartSpeed: 1000,
				nav: true,
				navText: [
					'<div class="link" data-title="Prev" data-dir="left"></div>',
					'<div class="link" data-title="Next" data-dir="right"></div>',
				],
		};

		$(this).owlCarousel(options);
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js